import React, { useEffect, useRef, useState } from "react";
import ViewPreOrderInfo from "../../../BookModule.module.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Download, Search } from "@mui/icons-material";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { AxiosInstance } from "../../../../../../../axios";
import { ImageUrlPrefix, R_PER_PAGE } from "../../../../../../../labels";
import ViewIcon from "../../BookTabs/ViewIcon.png";
import Pagination from "../../../../../../ReusuableComponent/Pagination/Pagination";
import moment from "moment";
import Loader from "../../../../../Loader";
import { clearBookFilters, setBookFilters } from "../../../../../../../redux/purchaseBookFilterSlice";
import { useDispatch, useSelector } from "react-redux";
import fileDownload from "js-file-download";
import axios from "axios";
export default function ViewPreOrder() {
  const navigate = useNavigate();
  const { bookID, ID } = useParams();
  const navigateToPreviousScreen = () => {
    navigate(-1);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const location = useLocation();
  const { CATEGORY, COURSE, SUBJECT, MEDIUM, SERIES, SEARCHTERM, DATE, PRICE, REDUXKEY } = location.state
    ? location.state
    : {};
  //  data load table
  let page = R_PER_PAGE;
  const filters = useSelector((state) => state.listBookFilter);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);
  const [updateChipData, setUpdateChipData] = useState([]);

  useEffect(() => {
    // Ensure filters are set up before making API calls
    setCategory_on(filters.category || []);
    setCourse_on(filters.course || []);
    setSubject_on(filters.subject || []);
    setMedium_on(filters.medium || []);
    setAvailable_to_user(filters.availableToUser || []);
    setInitialfields(filters.price || {})
    setIsFiltersInitialized(true);

    const allFilters = [
      ...(filters.category || []),
      ...(filters.course || []),
      ...(filters.subject || []),
      ...(filters.medium || []),
      ...(filters.availableToUser || []),
      ...(filters.visibleToUser || []),
      ...(filters.seriesTag || []),
      ...(filters.freeBook || []),
      ...(filters.comboOffer || []),
      ...(filters.price?.fromDate && filters.price?.toDate
        ? [
          {
            name: `${filters.price.fromDate} - ${filters.price.toDate}`,
            type: 'price',
          },
        ]
        : []),

    ];
    setUpdateChipData(allFilters);
  }, [filters]);

  useEffect(() => {
    if (
      REDUXKEY != 1 &&
      isFiltersInitialized &&
      filters &&
      Object.keys(filters).some((key) => filters[key]?.length > 0)
    ) {

      loadListdata();
    }
  }, [JSON.stringify(filters), isFiltersInitialized, updateChipData]);
  useEffect(() => {
    if (REDUXKEY == 1 || isFiltersInitialized && filters) {
      loadListdata();
    }
  }, [REDUXKEY, JSON.stringify(filters), isFiltersInitialized, updateChipData]);

  let filterAvalible_to_user = [];
  let filterCategory = [];
  let filterCourse = [];
  let filterSubject = [];
  let filterMedium = [];

  const filterRef_avaliable_to_user = useRef(null);
  const filterRef_category = useRef(null);
  const filterRef_mrp = useRef(null);
  const filterRef_course = useRef(null);
  const filterRef_subject = useRef(null);
  const filterRef_medium = useRef(null);

  const txtBSearch = useRef(null); //search icon
  const txtBSearch_course = useRef(null); //search icon
  const txtBSearch_sub = useRef(null);
  // use state
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [updateListData, setUpdateListData] = useState();
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  const [categoryId, setCategoryId] = useState([]);
  const [courseId, setCourseId] = useState([]);
  const [subjectId, setSubjectId] = useState([]);
  const [courseIds, setCourseIds] = useState([]);
  const [subjectIds, setSubjectIds] = useState([]);
  const [available_to_user, setAvailable_to_user] = useState([]);
  const [category_on, setCategory_on] = useState([]);
  const [course_on, setCourse_on] = useState([]);
  const [subject_on, setSubject_on] = useState([]);
  const [medium_on, setMedium_on] = useState([]);
  const [isOpen, setIsOpen] = useState({
    available_to_user: false,
    category: false,
    course: false,
    subject: false,
    medium: false,
    price: false,
  });
  const [initialfields, setInitialfields] = useState({
    fromDate: "",
    toDate: ""
  })
  const [dataView, setDataView] = useState({});

  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (filterRef_category.current &&
        !filterRef_category.current.contains(event.target)) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "category"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "category"
            );
            setCategory_on(updatedCategory);
          } else {
            setCategory_on([]);
          }
          setIsOpen((prev) => ({ ...prev, category: false }));
        }
      } if (filterRef_mrp.current &&
        !filterRef_mrp.current.contains(event.target)) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "price"
          );
          if (hasAuthor) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "price"
            );
            // alert("1")
            const [fromDate, toDate] = updatedAuthor[0].name.split(" - ").map((val) => val.trim());

            setInitialfields({ fromDate, toDate });
          } else {
            // alert("2")

            setInitialfields({ fromDate: "", toDate: "" });
          }
          setIsOpen((prev) => ({ ...prev, price: false }));
        }
      }
      if (filterRef_course.current &&
        !filterRef_course.current.contains(event.target)) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "course"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "course"
            );
            setCourse_on(updatedCategory);
          } else {
            setCourse_on([]);
          }
          setIsOpen((prev) => ({ ...prev, course: false }));
        }
      }
      if (filterRef_subject.current &&
        !filterRef_subject.current.contains(event.target)) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "subject"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "subject"
            );
            setSubject_on(updatedCategory);
          } else {
            setSubject_on([]);
          }
          setIsOpen((prev) => ({ ...prev, subject: false }));
        }
      }
      if (filterRef_medium.current &&
        !filterRef_medium.current.contains(event.target)) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "medium"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "medium"
            );
            setMedium_on(updatedCategory);
          } else {
            setMedium_on([]);
          }
          setIsOpen((prev) => ({ ...prev, medium: false }));
        }
      } if (filterRef_avaliable_to_user.current &&
        !filterRef_avaliable_to_user.current.contains(event.target)) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "available_to_user"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "available_to_user"
            );
            setAvailable_to_user(updatedCategory);
          } else {
            setAvailable_to_user([]);
          }
          setIsOpen((prev) => ({ ...prev, available_to_user: false }));
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData, category_on, course_on, subject_on, medium_on]);

  useEffect(() => {
    filterCategory = category_on;
  }, [category_on]);

  useEffect(() => {
    filterCourse = course_on;
  }, [course_on]);
  useEffect(() => {
    filterSubject = subject_on;
  }, [subject_on]);
  useEffect(() => {
    filterMedium = medium_on;
  }, [medium_on]);

  useEffect(() => {
    filterAvalible_to_user = available_to_user;
  }, [available_to_user]);


  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          setCategoryId(res.data.data);
        } else {
          setCategoryId([]);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);
  const handleChange = (event) => {
    let { name, value } = event.target;
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  }
  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);

  const currentData = updateListData?.slice(start, end);



  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const handleFilterCourseSearch = (event, names) => {
    if (names == "course") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = courseId.filter(
          (item) =>
            item.course_name &&
            item.course_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setCourseIds(matchingObjects);
      } else {
        setCourseIds(courseId);
      }
    } else if (names == "subject") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = subjectId.filter(
          (item) =>
            item.subject_name &&
            item.subject_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setSubjectIds(matchingObjects);
      } else {
        setSubjectIds(subjectId);
      }
    }
  };

  const handleFilterSearchFocus = (name) => {
    if (name == "course") {
      if (txtBSearch_course.current) {
        txtBSearch_course.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_course.current.dispatchEvent(event);
      }
    } else if (name == "subject") {
      if (txtBSearch_sub.current) {
        txtBSearch_sub.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_sub.current.dispatchEvent(event);
      }
    }
  };

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
    setSortColumn(sortKey);
  };

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "category_on") {
      if (checked) {
        setCategory_on([
          ...category_on,
          { id: value, name: name, type: "category" },
        ]);
      } else {
        setCategory_on(category_on.filter((item) => item.id !== value));
      }
    } else if (typename === "course") {
      if (checked) {
        setCourse_on([...course_on, { id: value, name: name, type: "course" }]);
      } else {
        setCourse_on(course_on.filter((item) => item.id !== value));
      }
    } else if (typename === "subject") {
      if (checked) {
        setSubject_on([
          ...subject_on,
          { id: value, name: name, type: "subject" },
        ]);
      } else {
        setSubject_on(subject_on.filter((item) => item.id !== value));
      }
    } else if (typename === "medium") {
      if (checked) {
        setMedium_on([...medium_on, { id: value, name: name, type: "medium" }]);
      } else {
        setMedium_on(medium_on.filter((item) => item.id !== value));
      }
    } else if (typename === "available_to_user") {
      if (checked) {
        setAvailable_to_user([
          // ...available_to_user,
          { id: value, name: name, type: "available_to_user" },
        ]);
      } else {
        setAvailable_to_user(
          available_to_user.filter((item) => item.id !== value)
        );
      }
    }
  };

  function loadListdata() {
    let tempCate = [];
    let tempSubj = [];
    let tempCourse = [];
    let tempMedium = [];
    let tempAvailUser = [];
    let tempCateName = [];
    let tempMediumName = [];
    let tempFreeBook = [];
    let tempComboOffer = [];
    let tempCourseName = [];
    let tempSubjectName = [];
    category_on?.map((obj) => {
      tempCate.push(Number(obj.id));
    });
    course_on?.map((obj) => {
      tempCourse.push(Number(obj.id));
    });
    subject_on?.map((obj) => {
      tempSubj.push(Number(obj.id));
    });
    medium_on?.map((obj) => {
      tempMedium.push(Number(obj.id));
    });
    available_to_user?.map((obj) => {
      tempAvailUser.push(Number(obj.id));
    });
    category_on?.map((obj) => {
      tempCateName.push(obj.name);
    });
    course_on?.map((obj) => {
      tempCourseName.push(obj.name);
    });
    subject_on?.map((obj) => {
      tempSubjectName.push(obj.name);
    });
    medium_on?.map((obj) => {
      tempMediumName.push(obj.name);
    });

    let statusFilter = {
      id: parseInt(ID),
      category_id: "",
      group_course_id: "",
      subject_id: "",
      medium: "",
      // select_set_list: available_to_user.length > 0 ? tempAvailUser : "",
      visible_user: available_to_user.length > 0 ? tempAvailUser : "",
      start_range_mrp: initialfields.fromDate || "",
      end_range_mrp: initialfields.toDate || "",
      category_name: category_on.length > 0 ? tempCateName : "",
      group_course_name: course_on.length > 0 ? tempCourseName : "",
      subject_name: subject_on.length > 0 ? tempSubjectName : "",
      medium_name: medium_on.length > 0 ? tempMediumName : "",
    };
    setIsLoading(true);
    AxiosInstance.post("api/book/preorder_view", statusFilter)
      .then((res) => {

        if (res.data.status) {
          const HDF = res.data.data;
          setDataView(HDF);
          const HDDATA = res.data.set_details;
          const serialNumberAddedData = HDDATA.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setUpdateListData(serialNumberAddedData);
          getAPCSData(serialNumberAddedData);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setDataView({});
          setUpdateListData([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }

  function getAPCSData(data) {
    if (data.length > 0) {
      const seenCourseIds = new Set();
      const seenSubjectIds = new Set();
      const CourseDatas = data
        .filter((es) => {
          if (!es.group_course_name || seenCourseIds.has(es.group_course_name)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenCourseIds.add(es.group_course_name);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          course_name: es.group_course_name,
          course_id: es.group_course_id,
        }));

      setCourseId(CourseDatas);
      setCourseIds(CourseDatas);
      const SubjectDatas = data
        .filter((es) => {
          if (!es.subject_name || seenSubjectIds.has(es.subject_name)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenSubjectIds.add(es.subject_name);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          subject_name: es.subject_name,
          subject_id: es.subject_id,
        }));

      setSubjectId(SubjectDatas);
      setSubjectIds(SubjectDatas);
    }
  }

  function loadChipdata() {
    let tempArr = [];

    if (initialfields.fromDate || initialfields.toDate) {
      tempArr.push({
        name: ` ${initialfields.fromDate || 0} - ${initialfields.toDate || 0}`,
        value: `MRP`,
        type: "price"
      });
    }
    filterAvalible_to_user.map((obj) => {
      tempArr.push(obj);
    });
    filterCategory.map((obj) => {
      tempArr.push(obj);
    });
    filterCourse.map((obj) => {
      tempArr.push(obj);
    });
    filterSubject.map((obj) => {
      tempArr.push(obj);
    });
    filterMedium.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
    // loadListdata();
  }

  function updateStateData() {
    filterAvalible_to_user = available_to_user;
    filterCategory = category_on;
    filterCourse = course_on;
    filterSubject = subject_on;
    filterMedium = medium_on;

  }

  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "available_to_user") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        available_to_user: false,
      });
    }
    else if (name === "price") {
      loadChipdata();
      // let tempArr = [];
      // if (initialfields.fromDate || initialfields.toDate) {
      //   tempArr.push({
      //     name: `${initialfields.fromDate || 0} - ${initialfields.toDate || 0}`,
      //     value: `MRP`,
      //     type: "price"
      //   });
      // }
      // setUpdateChipData(tempArr); loadListdata();
      setIsOpen({
        ...isOpen,
        price: false,
      });
    } else if (name === "category") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "course") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        course: false,
      });
    } else if (name === "subject") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        subject: false,
      });
    } else if (name === "medium") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        medium: false,
      });
    }
  };

  const handleClear = (name) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      available_to_user: false,
      category: false,
      course: false,
      subject: false,
      medium: false,
    });
    if (name === "available_to_user") {
      setAvailable_to_user([]);
      filterAvalible_to_user = [];
    } else if (name === "category") {
      setCategory_on([]);
      filterCategory = [];
    } else if (name === "course") {
      setCourse_on([]);
      filterCourse = [];
    } else if (name === "subject") {
      setSubject_on([]);
      filterSubject = [];
    } else if (name === "medium") {
      setMedium_on([]);
      filterMedium = [];
    } else if (name === "price") {
      setInitialfields({});
      setIsOpen({
        ...isOpen,
        price: false,
      });
    }
  };

  const handleFilter = (e, boxName) => {
    if (boxName === "available_to_user") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        available_to_user: !prevState.available_to_user, // Toggle the value
        category: false,
        course: false,
        subject: false,
        medium: false,
      }));
      setAvailable_to_user(
        updateChipData.filter((ui) => ui.type === "available_to_user")
      );
    } else if (boxName === "category") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        category: !prevState.category, // Toggle the value
        visible_to_user: false,
        publisher: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setCategory_on(updateChipData.filter((ui) => ui.type === "category"));
    } else if (boxName === "course") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        course: !prevState.course, // Toggle the value
        category: false,
        visible_to_user: false,
        publisher: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setCourse_on(updateChipData.filter((ui) => ui.type === "course"));
    } else if (boxName === "subject") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        subject: !prevState.subject, // Toggle the value
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        medium: false,
        author: false,
      }));
      setSubject_on(updateChipData.filter((ui) => ui.type === "subject"));
    } else if (boxName === "medium") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        medium: !prevState.medium, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        available_to_user: false,
        author: false,
      }));
      setMedium_on(updateChipData.filter((ui) => ui.type === "medium"));
    } else if (boxName === "price") {
      setIsOpen((prevState) => ({
        ...prevState,
        seriesTag: false,
        subject: false,
        course: false,
        category: false,
        is_visible: false,
        publisher: false,
        author: false,
        is_combo_offer: false,
        is_free_book: false,
        price: !prevState.price,
        availableToUser: false,
        medium: false,
      }));
    }
  };
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    let shouldReloadChipData = true;
    if (chipToDelete.type === "price") {
      setInitialfields({ fromDate: "", toDate: "" });
      setUpdateChipData((prevChips) =>
        prevChips.filter((chip) => chip.type !== "price")
      );
      shouldReloadChipData = false;
    }
    else if (chipToDelete.type === "available_to_user") {
      setAvailable_to_user(
        available_to_user.filter((item) => item.id !== chipToDelete.id)
      );
      filterAvalible_to_user = available_to_user.filter(
        (item) => item.id !== chipToDelete.id
      );


    } else if (chipToDelete.type === "category") {
      setCategory_on(category_on.filter((item) => item.id !== chipToDelete.id));
      filterCategory = category_on.filter(
        (item) => item.id !== chipToDelete.id
      );

    } else if (chipToDelete.type === "course") {

      setCourse_on(course_on.filter((item) => item.id !== chipToDelete.id));
      filterCourse = course_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "subject") {
      setSubject_on(subject_on.filter((item) => item.id !== chipToDelete.id));
      filterSubject = subject_on.filter((item) => item.id !== chipToDelete.id);

    } else if (chipToDelete.type === "medium") {
      setMedium_on(medium_on.filter((item) => item.id !== chipToDelete.id));
      filterMedium = medium_on.filter((item) => item.id !== chipToDelete.id);

    }
    if (shouldReloadChipData) {
      loadChipdata();
    }
  };

  const handleAllClear = () => {
    setMedium_on([]);
    setSubject_on([]);
    setCourse_on([]);
    setInitialfields({});
    setCategory_on([]);
    setAvailable_to_user([]);
    setUpdateChipData([]);
  };
  const dispatch = useDispatch();
  const handleEditPreorder = (bosokIDX, idss) => {
    dispatch(clearBookFilters());
    navigate(`/studyMaterials/Books/EditPreOrder/${bosokIDX}/${idss}`);
  };

  const handleNavigate = () => {
    navigate(`/studyMaterials/Books/List/3`, {
      state: {
        fillCate: CATEGORY,
        fillCourse: COURSE,
        fillSub: SUBJECT,
        fillMedium: MEDIUM,
        fillSearch: SEARCHTERM,
        filSeries: SERIES,
        filSearch: SEARCHTERM,
        filDate: DATE,
        filPrice: PRICE
      },
    });

    // navigate(-1);
  };
  const handleView = (bookIds, id) => {
    dispatch(
      setBookFilters({
        category: category_on,
        course: course_on,
        subject: subject_on,
        medium: medium_on,
        availableToUser: available_to_user,
        price: initialfields,
      })
    );
    navigate(`/studyMaterials/Books/ViewBookSet/${bookIds}/${id}`, {
      // navigate(`/viewIndividualBook/${id}`, {
      state: {
        LABEL: "Back to View Pre-order",
        IDS:ID,
        BOOKIDS:bookID
      },
    });
  };
  const handleDownload = (url, filename) => {
    axios
      .get(`${ImageUrlPrefix}/${dataView.preview_path}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className="BathHeader global_container BathDet">
      <div className="row mx-0">
        <div className="col-md-6 col-12 px-0">
          <h2 className="TitleHeader">View Pre-Order</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={() => handleNavigate()}
                className="secondaryButton "
                variant="secondary"
              >
                Back to Books
              </Link>
            </li>
            <li
              className="ListBtnItems"
              onClick={() => handleEditPreorder(bookID, ID)}
            >
              <Link to={"javascript:void(0)"} className="primaryButton">
                <span class="material-icons align-middle ">border_color</span>{" "}
                Edit Pre-Order
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={ViewPreOrderInfo.preorderContainer}>
            <legend className="w-auto mb-0">Book Details</legend>
            <div className="row mx-0 mb-2">
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Book Name</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.book_title ? dataView.book_title : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Author</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.author ? dataView.author : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Publisher</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.publisher ? dataView.publisher : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">ISBN Number</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {dataView.isbn_no ? dataView.isbn_no : "_"}
                  </p>
                </div>
              </div>
            </div>

            <div className="row mx-0">
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Total Number of Pages</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.total_pages ? dataView.total_pages : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex">
                    <p className="confirm_label m-0 p-0">
                      Sample Pages
                    </p>

                    {dataView.preview_path ? (
                      <a
                        // href={`${ImageUrlPrefix}/${dataView.original_preview_path}`}
                        // target="_blank"
                        to="javascript:void(0)"
                        onClick={() =>
                          handleDownload(
                            dataView.preview_path,
                            dataView.original_preview_path
                          )
                        }
                      >
                        <Download className="download_icon" />
                      </a>
                    ) : (<>
                    </>)}

                  </div>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.original_preview_path ? dataView.original_preview_path : "_"}
                  </p>
                </div>
              </div>
            </div>

            <div className="row mx-0">
              <div className="px-0  col-lg-12 col-md-12 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Iframe URL</p>
                  <p className="confirm_value text-justify my-1 m-0 p-0">
                    {dataView.iframe ? dataView.iframe : "_"}
                  </p>
                </div>
              </div>
            </div>
            <div className="row mx-0">
              <div className="px-0  col-lg-12 col-md-12 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Description</p>
                  <p className="confirm_value text-justify my-1 m-0 p-0">
                    {dataView.description ? dataView.description : "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={ViewPreOrderInfo.preorderContainer}>
            <legend className="w-auto mb-0">Pre-Order Details</legend>
            <div className="row mx-0 ">
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Pre-Order Count</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.order_count ? dataView.order_count : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Purchase Count</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.purchase_count !== null
                      ? dataView.purchase_count
                      : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Expected by Date</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.expected_date
                      ? moment(dataView.expected_date).format("DD/MM/YYYY")
                      : "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row mx-0 mt-3 mb-4">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12 px-0">
          <fieldset className={ViewPreOrderInfo.preorderContainer}>
            <legend className="w-auto mb-0">Listed Booksets</legend>
            {updateChipData?.length > 0 ? (
              <div className="row mt-3">
                <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      listStyle: "none",
                      p: 0.5,
                      m: 0,
                    }}
                    component="ul"
                  >
                    {updateChipData.map((data, index) => {
                      let icon;
                      return (
                        <ListItem key={index}>
                          <Chip
                            icon={icon}
                            label={
                              <>
                                <span className={ViewPreOrderInfo.BoldTyText}>
                                  {data.type === "price" ? `Price: ${data.name}` : data.name}
                                </span>
                              </>
                            }
                            onDelete={handleDelete(data, index)}
                          />
                        </ListItem>
                      );
                    })}
                    <ListItem className="clearAll_list">
                      <a
                        className="clearAll_listItem"
                        href="javascript:void(0)"
                        onClick={handleAllClear}
                      >
                        Clear All Filters
                      </a>
                    </ListItem>
                  </Paper>
                </div>
              </div>
            ) : (
              <div></div>
            )}
            <div className="row mx-0 mt-2">
              <div
                className={`col-md-12 ${ViewPreOrderInfo.table_responsive_padding} table-responsive tableMinHeight px-0 `}
              >
                <table className="table" id="tableListHeader">
                  <thead>
                    <tr>
                      <th id="th" className={ViewPreOrderInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "serialNumber")}
                          className="textHead_th"
                        >
                          S.No.
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "serialNumber")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={ViewPreOrderInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "book_title")}
                          className="textHead_th"
                        >
                          Bookset Name
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "book_title")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={ViewPreOrderInfo.tableThPadding} ref={filterRef_mrp}>
                        <span
                          onClick={(e) => handleSort(e, "price")}
                          className="textHead_th"

                        >
                          MRP
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "price")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${(initialfields.fromDate || initialfields.toDate || isOpen.price)
                            ? ViewPreOrderInfo.active_icons_book
                            : ""
                            } `}
                          onClick={(e) => handleFilter(e, "price")}
                        >
                          filter_list
                        </span>
                        {isOpen.price === true && (
                          <div className="filterBoxs p-1 mt-3">
                            <div className="row ">
                              <div className="col-md-12">
                                <div>
                                  <div>
                                    <label for="bookName" class="form-label confirm_value ">
                                      From
                                    </label>
                                  </div>
                                  <input
                                    class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                    type="number"
                                    id="fromDate"
                                    name="fromDate"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Enter the from price"
                                    value={initialfields.fromDate}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div>
                                  <div>
                                    <label for="bookName" class="form-label confirm_value ">
                                      To
                                    </label>
                                  </div>
                                  <input
                                    class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                    type="number"
                                    id="toDate"
                                    name="toDate"
                                    maxLength={50}
                                    placeholder="Enter the to price"
                                    value={initialfields.toDate}
                                    onChange={handleChange}
                                  />
                                </div>
                                {/* <div class="form-check">
                                                                            <MultiRangeSlider
                                                                              handleChangeFilter={handleChangeFilter}
                                                                              ranges={ranges}
                                                                            />
                                                                          </div> */}
                              </div>
                            </div>
                            <hr />
                            <div className="row mt-3">
                              <div className="col-md-4  col-4 col-sm-4">
                                <span
                                  className="clearFilter ms-2 "
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleClear("price")}
                                >
                                  Clear
                                </span>
                              </div>
                              <div className="col-md-8  col-8 col-sm-8">
                                <button
                                  className="FilterButton"
                                  onClick={() => handleApplyFilter("price")}
                                >
                                  Apply Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </th>
                      <th id="th" className={ViewPreOrderInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "offer_percentage")}
                          className="textHead_th"
                        >
                          Offer %
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "offer_percentage")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={ViewPreOrderInfo.tableThPadding}>
                        <div class={ViewPreOrderInfo.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "finalPrice")}
                            class="textHead_th"
                          >
                            Final <br /> Price
                          </span>
                          <div class={ViewPreOrderInfo.iconcontainer}>
                            <span
                              onClick={(e) => handleSort(e, "finalPrice")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </div>
                        </div>
                      </th>{" "}
                      <th id="th" className={ViewPreOrderInfo.tableThPadding}>
                        <div class={ViewPreOrderInfo.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "totalBooksCount")}
                            class="textHead_th"
                          >
                            No. of <br /> Books
                          </span>
                          <div class={ViewPreOrderInfo.iconcontainer}>
                            <span
                              onClick={(e) => handleSort(e, "totalBooksCount")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </div>
                        </div>
                      </th>{" "}
                      <th id="th" className={ViewPreOrderInfo.tableThPadding} ref={filterRef_category}>
                        <span
                          onClick={(e) => handleSort(e, "category_name")}
                          className="textHead_th"
                        >
                          Category
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "category_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${category_on.length > 0
                            ? ViewPreOrderInfo.active_icons_book
                            : ""
                            } ${isOpen.category
                              ? ViewPreOrderInfo.active_icons_book
                              : ""
                            }`} // Change here
                          onClick={(e) => handleFilter(e, "category")}
                        >
                          filter_list
                        </span>

                        {isOpen.category && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {categoryId.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.name}
                                        value={el.id}
                                        id={el.name}
                                        checked={category_on.some((element) => {
                                          if (element.id == el.id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.name,
                                            "category_on"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.name}
                                      >
                                        {el.name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <Link
                                    to={"javascript:void(0)"}
                                    onClick={() => handleClear("category")}
                                    className="secondaryButton "
                                  >
                                    Clear
                                  </Link>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        category_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("category")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>

                          </>
                        )}
                      </th>
                      <th id="th" className={ViewPreOrderInfo.tableThPadding} ref={filterRef_course}>
                        <span
                          onClick={(e) => handleSort(e, "group_course_name")}
                          className="textHead_th"
                        >
                          Course
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "group_course_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${course_on.length > 0
                            ? ViewPreOrderInfo.active_icons_book
                            : ""
                            } ${isOpen.course
                              ? ViewPreOrderInfo.active_icons_book
                              : ""
                            }`} // Change here
                          onClick={(e) => handleFilter(e, "course")}
                        >
                          filter_list
                        </span>
                        {isOpen.course && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li
                                    className={`filterListData ${ViewPreOrderInfo.searchInputSec}`}
                                  >
                                    <input
                                      className={`${ViewPreOrderInfo.searchInput} w-100`}
                                      type="text"
                                      placeholder="Search by course"
                                      name="search_book_title"
                                      onKeyDown={(e) =>
                                        handleFilterCourseSearch(e, "course")
                                      }
                                      ref={txtBSearch_course}
                                    />
                                    <Search
                                      onClick={(e) =>
                                        handleFilterSearchFocus("course")
                                      }
                                      className={`${ViewPreOrderInfo.ListsearchIcon}`}
                                    />
                                  </li>
                                  {courseIds.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.course_name}
                                        value={el.course_id}
                                        id={el.course_name}
                                        checked={course_on.some((element) => element.name === el.course_name)}
                                        // checked={course_on.some((element) => {
                                        //   if (element.id == el.course_id) {
                                        //     return true;
                                        //   }
                                        //   return false;
                                        // })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.course_name,
                                            "course"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.course_name}
                                      >
                                        {el.course_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("course")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        course_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("course")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      <th id="th" className={ViewPreOrderInfo.tableThPadding} ref={filterRef_subject}>
                        <span
                          onClick={(e) => handleSort(e, "subject_name")}
                          className="textHead_th"
                        >
                          Subject
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "subject_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${subject_on.length > 0
                            ? ViewPreOrderInfo.active_icons_book
                            : ""
                            } ${isOpen.subject
                              ? ViewPreOrderInfo.active_icons_book
                              : ""
                            }`} // Change here
                          onClick={(e) => handleFilter(e, "subject")}
                        >
                          filter_list
                        </span>
                        {isOpen.subject && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li
                                    className={`filterListData ${ViewPreOrderInfo.searchInputSec}`}
                                  >
                                    <input
                                      className={`${ViewPreOrderInfo.searchInput} w-100`}
                                      type="text"
                                      placeholder="Search by subject"
                                      name="search_book_title"
                                      onKeyDown={(e) =>
                                        handleFilterCourseSearch(e, "subject")
                                      }
                                      ref={txtBSearch_sub}
                                    />
                                    <Search
                                      onClick={() =>
                                        handleFilterSearchFocus("subject")
                                      }
                                      className={`${ViewPreOrderInfo.ListsearchIcon}`}
                                    />
                                  </li>
                                  {subjectIds.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.subject_name}
                                        value={el.subject_id}
                                        id={el.subject_name}

                                        checked={subject_on.some((element) => element.name === el.subject_name)}
                                        // checked={subject_on.some((element) => {
                                        //   if (element.id == el.subject_id) {
                                        //     return true;
                                        //   }
                                        //   return false;
                                        // })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.subject_name,
                                            "subject"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.subject_name}
                                      >
                                        {el.subject_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("subject")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        subject_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("subject")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>

                          </>
                        )}
                      </th>
                      <th id="th" className={ViewPreOrderInfo.tableThPadding} ref={filterRef_medium}>
                        <span
                          onClick={(e) => handleSort(e, "medium")}
                          className="textHead_th"
                        >
                          Medium
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "medium")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${medium_on.length > 0
                            ? ViewPreOrderInfo.active_icons_book
                            : ""
                            } ${isOpen.medium
                              ? ViewPreOrderInfo.active_icons_book
                              : ""
                            }`} // Change here
                          onClick={(e) => handleFilter(e, "medium")}
                        >
                          filter_list
                        </span>
                        {isOpen.medium && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Tamil"}
                                      value={"0"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "0") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"medium_tamil"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"medium_tamil"}
                                    >
                                      Tamil
                                    </label>
                                  </li>
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"English"}
                                      value={"1"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "1") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"medium_english"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"medium_english"}
                                    >
                                      English
                                    </label>
                                  </li>
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Both"}
                                      value={"2"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "2") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"Both"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"Both"}
                                    >
                                      Both
                                    </label>
                                  </li>
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("medium")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        medium_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("medium")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>

                          </>
                        )}
                      </th>
                      <th id="th" className={ViewPreOrderInfo.tableThPadding} ref={filterRef_avaliable_to_user}>
                        <div class={ViewPreOrderInfo.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "availableToUser")}
                            class="textHead_th"
                          >
                            Available <br /> to Users
                          </span>
                          <div class={ViewPreOrderInfo.iconcontainer}>
                            <span
                              onClick={(e) => handleSort(e, "availableToUser")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${available_to_user.length > 0
                                ? ViewPreOrderInfo.active_icons_book
                                : ""
                                } ${isOpen.available_to_user
                                  ? ViewPreOrderInfo.active_icons_book
                                  : ""
                                }`} // Change here
                              onClick={(e) =>
                                handleFilter(e, "available_to_user")
                              }
                            >
                              filter_list
                            </span>
                          </div>
                        </div>
                        {isOpen.available_to_user && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Yes"}
                                      value={"1"}
                                      checked={available_to_user.some(
                                        (element) => {
                                          if (element.id == "1") {
                                            return true;
                                          }
                                          return false;
                                        }
                                      )}
                                      id={"available_to_user_yes"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "available_to_user",
                                          "available_to_user"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"available_to_user_yes"}
                                    >
                                      Yes
                                    </label>
                                  </li>
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"No"}
                                      value={"0"}
                                      checked={available_to_user.some(
                                        (element) => {
                                          if (element.id == "0") {
                                            return true;
                                          }
                                          return false;
                                        }
                                      )}
                                      id={"available_to_user_no"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "available_to_user",
                                          "available_to_user"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"available_to_user_no"}
                                    >
                                      No
                                    </label>
                                  </li>
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() =>
                                        handleClear("available_to_user")
                                      }
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        available_to_user.length === 0
                                          ? true
                                          : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("available_to_user")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>

                          </>
                        )}
                      </th>
                      <th id="th" className={ViewPreOrderInfo.tableThPadding}>
                        <span className="textHead_th">Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData?.length === 0 ? (
                      <tr>
                        <td colspan="15" style={{ textAlign: "center" }}>
                          No records to display
                        </td>
                      </tr>
                    ) : (
                      currentData?.map((kl, ind) => (
                        <tr key={ind}>
                          <td id="td">{kl.serialNumber}</td>
                          <td id="td">
                            <span
                              title={kl.book_name}
                              className={ViewPreOrderInfo.ellipsisText}
                            >
                              {kl.book_name}
                            </span>
                          </td>
                          <td id="td">{kl.price ? kl.price : "_"}</td>
                          <td id="td">
                            {kl.offer_percentage ? kl.offer_percentage : "0"}
                          </td>
                          <td id="td">{kl.finalPrice ? kl.finalPrice : "0"}</td>
                          <td id="td">
                            {kl.totalBooksCount ? kl.totalBooksCount : "_"}
                          </td>
                          <td id="td">
                            {kl.category_name ? kl.category_name : "_"}
                          </td>
                          <td id="td">

                            <span
                              title={kl.group_course_name}
                              className={ViewPreOrderInfo.ellipsisText}
                            >
                              {kl.group_course_name}
                            </span>
                          </td>
                          <td id="td">
                            <span
                              title={kl.subject_name}
                              className={ViewPreOrderInfo.ellipsisText}
                            >
                              {kl.subject_name}
                            </span>
                          </td>
                          <td id="td">{kl.medium ? kl.medium : "_"}</td>
                          {/* <td id="td">
                            {kl.availableToUser
                              ? kl.availableToUser == 1
                                ? "Yes"
                                : "No"
                              : "_"}
                          </td> */}
                          <td id="td">{kl.availableToUser == 1 ? "Yes" : "No"}</td>
                          <td id="td">
                            <img
                              src={ViewIcon}
                              className={ViewPreOrderInfo.cursor_pointer}
                              alt="view icon"
                              onClick={(e) => handleView(kl.book_ids, kl.id)}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row mt-2">
              <Pagination
                rowsPerPage={rowsPerPage}
                handlePageCount={handlePageCount}
                startPage={
                  updateListData && updateListData?.length > 0
                    ? currentPage * rowsPerPage + 1 - rowsPerPage
                    : 0
                }
                endPage={
                  updateListData && updateListData?.length > 0
                    ? updateListData?.length < currentPage * rowsPerPage
                      ? updateListData?.length
                      : currentPage * rowsPerPage
                    : 0
                }
                totalRecords={
                  updateListData && updateListData?.length > 0
                    ? updateListData?.length
                    : 0
                }
                handlePrev={(e) => handlePrev(currentPage - 1)}
                currentPrevPage={currentPage === 1}
                prevButton={`${ViewPreOrderInfo.prev_buttonViewAllbook} ${ViewPreOrderInfo.materialIconsRightAndLeft} me-2`}
                handleNext={() => handleNext(currentPage + 1)}
                currentNextPage={currentPage === totalPages || totalPages == 0}
              />
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
}
